import React from "react";

import { Input, FormControl } from "kanopi-components/Input";

import { WidthContainer } from "../../ChatFlow/WidthContainer";

interface EmailInputProps {
  label?: string;
  title?: string;
  help?: string;
  error?: boolean;
  [key: string]: unknown; // This allows passing additional props to CurrencyInput
}
export function EmailInput({ label, title, help, error, ...props }: EmailInputProps) {
  return (
    <WidthContainer>
      <FormControl label={label} title={title} caption={help} error={error}>
        <Input {...props} inputMode="email" />
      </FormControl>
    </WidthContainer>
  );
}
